import { render, staticRenderFns } from "./SmsBroadcastStatistic.vue?vue&type=template&id=5099201a"
import script from "./SmsBroadcastStatistic.vue?vue&type=script&lang=js"
export * from "./SmsBroadcastStatistic.vue?vue&type=script&lang=js"
import style0 from "./SmsBroadcastStatistic.vue?vue&type=style&index=0&id=5099201a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports